import { useInfiniteQuery } from "@tanstack/react-query";
import { ChatsQueryKeys } from "./chatsQueryKeys";
import {
  getChatMessagesPaginated,
  ChatMessagesPaginatedResponse,
} from "@/api/chats";

export const useChatMessagesPaginated = (
  chatId: number | null,
  limit = 50
) => {
  return useInfiniteQuery<ChatMessagesPaginatedResponse, Error>({
    queryKey: [ChatsQueryKeys.ChatMessagesPaginated, chatId],
    queryFn: async ({ signal, pageParam }) => {
      if (!chatId) {
        return {
          meta: {
            totalItems: 0,
            itemCount: 0,
            currentPage: 1,
            itemsPerPage: limit,
            totalPages: 0,
          },
          data: [],
        };
      }
      return getChatMessagesPaginated({
        signal,
        params: {
          chatId,
          page: pageParam as number,
          limit,
        },
      });
    },
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      if (!lastPage.meta) return undefined;
      const { currentPage, totalPages } = lastPage.meta;
      return currentPage < totalPages ? currentPage + 1 : undefined;
    },
    enabled: Boolean(chatId),
  });
};
